import { render, staticRenderFns } from "./GuestInfoRight.vue?vue&type=template&id=50a58808&scoped=true"
import script from "./GuestInfoRight.vue?vue&type=script&lang=js"
export * from "./GuestInfoRight.vue?vue&type=script&lang=js"
import style0 from "./GuestInfoRight.vue?vue&type=style&index=0&id=50a58808&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a58808",
  null
  
)

export default component.exports